import axios, { AxiosRequestConfig } from 'axios';
import Cookies from 'universal-cookie';

import AuthService from '../auth/authService';
import { window } from 'window-or-global';
import {
    JWT_COOKIE_KEY,
    JWT_EXPIRE_DAYS,
    JWT_HEADER,
} from '@/constants/constantsAckoDrive';
import { getLoginUrl } from '@/utils/getLoginUrl';

const axiosInstance = axios.create();

interface AxiosConfigWithMetadata extends AxiosRequestConfig {
    metadata?: any;
}

axiosInstance.interceptors.request.use(
    function (axiosConfig: any) {
        const config: any = axiosConfig;
        if (typeof window !== 'undefined') {
            // Keeping in the browser side only, as the server side won't have access to the browser cookies directly
            // We will need to update it if we want to SSR the user data content as well.
            try {
                const cookies = new Cookies();
                let actual_tokens = cookies.get(JWT_COOKIE_KEY) || {};
                let access_token;
                access_token = actual_tokens['access'] || '';
                if (!access_token) {
                    // window.location.href = getLoginUrl();
                    console.log('axios-interceptors is called');
                }
                config.headers.common[JWT_HEADER] = access_token;
            } catch (err) {}
        } else {
            config.metadata = { startTime: new Date() };
        }
        return config;
    },
    function (error: any) {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function (response: any) {
        // Structuring data with a common format
        let requestDuration;
        if (typeof window === 'undefined') {
            requestDuration =
                new Date().getTime() -
                (response.config as AxiosConfigWithMetadata)?.metadata
                    ?.startTime;
        }
        return {
            requestDuration:
                typeof window === 'undefined' ? requestDuration : undefined,
            data: response.data,
            is_loggedin: true,
        };
    },
    function (error: any) {
        // Do something with response error
        if (typeof window !== 'undefined') {
            if (error.response.status === 401) {
                // Unauthorized
                // Getting hold of stored tokens in the browser
                const cookies = new Cookies();
                let actual_tokens = cookies.get(JWT_COOKIE_KEY) || {};
                let refresh_token;
                refresh_token = actual_tokens['refresh'] || '';
                // Attempting to refresh the access token
                return AuthService.getNewAccessToken(refresh_token).then(
                    (reauthenticatedData?: any) => {
                        let new_access_token =
                            reauthenticatedData['access_token'];
                        let new_refresh_token =
                            reauthenticatedData['refresh_token'];
                        if (actual_tokens) {
                            actual_tokens['access'] = new_access_token;
                            actual_tokens['refresh'] = new_refresh_token;
                        }
                        // Storing the new tokens in browser for future requests
                        let expires = new Date();
                        expires.setDate(new Date().getDate() + JWT_EXPIRE_DAYS);
                        cookies.set(
                            JWT_COOKIE_KEY,
                            JSON.stringify(actual_tokens),
                            {
                                path: '/',
                                expires: expires,
                            }
                        );
                        error.config.headers[JWT_HEADER] = new_access_token;
                        error.config.baseURL = undefined;
                        // Reattempting the failed request
                        return axiosInstance.request(error.config);
                    },
                    function (err) {
                        // Refresh token is either invalid or has expired or is not present with browser. User has to login again.
                        cookies.remove(JWT_COOKIE_KEY, { path: '/' });
                        return {
                            data: undefined,
                            is_loggedin: false,
                        };
                    }
                );
            } else if (error.response.status === 403) {
                window.location.href = '/unauthorized';
            } else if (error.response.status === 400) {
                return {
                    data: error.response.data,
                    is_loggedin: false,
                };
            }
        }
        return {
            data: error.response.data,
            is_loggedin: false,
        };
    }
);

export default axiosInstance;
